module.exports = __webpack_public_path__ + "img/跨境知道.93d70111.png";